export const EMAIL_VALIDATOR = (t: Function) => t("bledny_format_adresu_email");
export const PHONE_VALIDATOR = (t: Function) => t("bledny_format_nr_telefonu");
export const LENGTH_VALIDATOR = (t: Function, length: number) => `${t("to_pole_musi_miec")} ${length} ${t("znakow")}`;
export const MAX_LENGTH_VALIDATOR = (t: Function, max: number) => t("pole_maksymalnie_znakow", { max });
export const MIN_VALIDATOR = (t: Function, min: number) => `${t("minimalna_wartosc_to")} ${min}`;
export const REQUIRED_VALIDATOR = (t: Function) => t("to_pole_jest_wymagane");
export const ZIP_CODE_VALIDATOR = (t: Function) => t("bledny_format_kodu_pocztowego");
export const PASSWORD_VALIDATOR = (t: Function) => t("ze_wzgledow_bezpieczenstwa_haslo_powinno_skladac_sie");
export const PASSWORDS_DO_NOT_MATCH = (t: Function) => t("hasla_nie_sa_zgodne");
export const EMAIL_DO_NOT_MATCH = (t: Function) => t("emaile_nie_sa_zgodne");
export const NIP_VALIDATOR = (t: Function) => t("bledny_format_wymagane");
export const TEXT_VALIDATOR = (t: Function) => t("uzyto_niedozwolonych_znakow");
